import { render, staticRenderFns } from "./ExamsOrdersDataTable.vue?vue&type=template&id=1ab1c2e5&scoped=true"
import script from "./ExamsOrdersDataTable.vue?vue&type=script&lang=js"
export * from "./ExamsOrdersDataTable.vue?vue&type=script&lang=js"
import style0 from "./ExamsOrdersDataTable.vue?vue&type=style&index=0&id=1ab1c2e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab1c2e5",
  null
  
)

export default component.exports